// ======================================================================
// File Name       : ContentQuestionEditBigHeader
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, FormControl, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../FormControlValidate';
import { VALIDATE_TYPE, ROOT_URL } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { getItemBoxName } from '../../utils/index';

class ContentQuestionEditBigHeader extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.onInputChange(name, value);
    } else {
      this.props.onInputChange(event, data);
    }
  };
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const {
      questionKind,
      questionSecernId,
      questionTitle,
      onInputChange,
      onFileChange,
      questionZipFileName,
      onShowDialogBtnClick,
      answerFormula,
      subQuestionArray,
    } = this.props;
    this.refsToValidate = [];
    return (
      <div>
        <h3>登録する項目を指定してください</h3>
        <Form className="col-sm-10 margin-top-10">
         <Col sm={12}>
            <Form.Group className="form-info">
            <Col as={Form.Label} sm={12}>
              <h3>基本設定</h3>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label} >問題形式</Col>
              <Col sm={3} as={Form.Label}>
                {getItemBoxName(SELECT_BOX_DATA.QUESTION_TYPE, questionKind)}
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={4}>
                問題識別ID
              </Col>
              <Col as={Form.Label} sm={7}>
                {questionSecernId}
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={4} className="margin-top-10">
                問題タイトル<span className="required">&nbsp;(※)</span>
              </Col>
              <Col as={Form.Label} sm={7}>
                <FormControlValidate
                  label="問題タイトル"
                  type="text"
                  name="questionTitle"
                  value={questionTitle}
                  onChange={this.onChange}
                  maxLength="256"
                  required
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={4}>
                <Col as={Form.Label} sm={12}>
                  問題フォーマット<span className="required">&nbsp;(※)</span>
                </Col>
                <Col as={Form.Label} sm={12}>
                  <a
                    className="float-start"
                    role="button"
                    href={ROOT_URL + '/manual/csvsample/bigQuestion_content.zip'}
                  >
                    <u>サンプルダウンロード</u>
                  </a>
                </Col>
              </Col>
              <Col sm={7} className="padding-left-clear">
                <FileUpload
                  labelName="ファイル選択"
                  inputId={'questionZipFileName'}
                  onChange={onFileChange}
                  accept={'application/zip,application/x-zip,application/x-zip-compressed'}
                  fileName={questionZipFileName}
                />
              </Col>
              <Col
                sm={7}
                as={Form.Label}
                className="margin-top-10">
                <FormControlValidate
                  label="問題内容"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={questionZipFileName && `ファイル名：${questionZipFileName}`}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={4}>小問の設定<span className="required">&nbsp;(※)</span></Col>
              <Col sm={3} className="padding-top-3 margin-left-15">
                <Button variant="primary" className="btn-96" onClick={onShowDialogBtnClick}>
                  追加
                </Button>
              </Col>
              <Col
                sm={{
                  span: 7,
                  offset: 4
                }}
                hidden={subQuestionArray.length > 0}>
                <FormControlValidate
                  label="小問情報"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={subQuestionArray.length ? subQuestionArray.length : ''}
                  required
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
            </Col>
          </Form.Group>
        </Col>
      </Form>
      </div>
    );
  }
}

export default ContentQuestionEditBigHeader;
